import CountryPage from "../components/CountryPage"
import Footer from "../components/footer"
import Header from "../components/header"

const CountryPages =()=>{
    return(
        <>
        {<Header/>}
        {<CountryPage/>}
      
        </>
    )
}
export default CountryPages